import { render, staticRenderFns } from "./PhoneOtpModal.vue?vue&type=template&id=f4696996&scoped=true&"
import script from "./PhoneOtpModal.vue?vue&type=script&lang=js&"
export * from "./PhoneOtpModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneOtpModal.vue?vue&type=style&index=0&id=f4696996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4696996",
  null
  
)

export default component.exports